<template>
    <ul v-if="pageCount > 1" class="pagination order-pagination">
        <li v-bind:class="{disabled: activePage < 1}"
            @click="activePage > 0 && setPage(activePage - 1)"
            class="page-item" >
            <a class="page-link">Zurück</a>
        </li>
        <li v-for="(rows, page) in rowsPerPage"
            v-bind:class="{active: activePage === page}"
            @click="setPage(page)"
            class="page-item" >
            <a class="page-link">{{page + 1}}</a>
        </li>
        <li v-bind:class="{disabled: activePage >= pageCount - 1}"
            @click="activePage < pageCount - 1 && setPage(activePage + 1)"
            class="page-item" >
            <a class="page-link">Weiter</a>
        </li>
    </ul>
</template>

<style lang="scss">
    @mixin pagination-color($color) {
        .order-pagination li a {
            color: $color !important;
        }
        .order-pagination li.active a {
            background-color: $color;
            border-color: $color;
        }
    }
    .peugeot {
        @include pagination-color(#003755);
    }
    .citroen {
        @include pagination-color(#2F2726);
    }
    .ds {
        @include pagination-color(#2F2726);
    }
    .order-pagination {
        user-select: none;
        li.active a {
            color: #ffffff !important;
        }
        li.disabled a {
            color: #777777 !important;
        }
    }
</style>

<script>
export default {

    data() {
        return {
            activePage: 0,
            table: null,
            rowsPerPage: [],
            rowCount: 0,
            pageCount: 0,
            rowCountPerPage: 5
        }
    },

    methods: {
        setPage(page) {
            this.activePage = page;
            let newTable = $('<tbody></tbody>').append(this.rowsPerPage[this.activePage]);
            this.table.find('tbody').replaceWith(newTable);
        }
    },

    mounted() {
        this.table = $('#order-table');
        this.rowCount = this.table.find('tbody').find('tr').length;
        this.pageCount = Math.ceil(this.rowCount / this.rowCountPerPage);
        for(let page = 0; page < this.pageCount; page++) {
            let startRow = page * this.rowCountPerPage;
            let lastRow = startRow + this.rowCountPerPage;
            if(startRow >= this.rowCount) {
                break;
            }
            let selector = "";
            for(let row = startRow + 1; row <= lastRow && row <= this.rowCount; row++) {
                selector += "tr:nth-child(" + row + "), ";
            }
            selector = selector.slice(0, -2);
            this.rowsPerPage[page] = this.table.find('tbody').find(selector);
        }
        if(this.rowCount !== 0) {
            this.setPage(0);
        }
        this.table.show();
        this.table.parent().find('.loading-icon').hide();
    },
}
</script>
